export default "__VITE_ASSET__BduPtGFP__"